<script lang="ts">
  import { type HTMLAttributes } from 'vue'
  import { Skeleton } from '../ui/skeleton'

  export type DataListAs = 'div' | 'ul' | 'ol'

  export interface DataListProps {
    as?: DataListAs
    divider?: boolean
    /** If true, the component will show a loading state */
    loading?: boolean
    /** If true, the component will show an empty state. Override the default rendering via the `empty` slot */
    empty?: boolean
    class?: HTMLAttributes['class']
  }
</script>

<script setup lang="ts">
  import { cn } from '../../lib/utils'
  import { IconCoffee } from '@gat-ship/icons'
  import { Empty, EmptyHeader, EmptyMedia, EmptyTitle } from '../ui/empty'

  const props = withDefaults(defineProps<DataListProps>(), {
    as: 'div',
    divider: true,
    loading: false,
    empty: false
  })

  // ai suggestions: add density, spacing, empty/loading props - keep those for later or in presets
</script>

<template>
  <component
    :is="props.as"
    :class="[
      cn('flex flex-col', props.class),
      { 'divide-border divide-y': props.divider },
      { 'divide-accent divide-y': props.loading }
    ]"
  >
    <slot v-if="props.loading" name="loading">
      <skeleton class="bg-accent h-24 w-full" />
    </slot>
    <slot v-else-if="props.empty" name="empty">
      <Empty>
        <EmptyHeader>
          <EmptyMedia variant="icon">
            <IconCoffee />
          </EmptyMedia>
          <EmptyTitle>Resource not found</EmptyTitle>
        </EmptyHeader>
      </Empty>
    </slot>
    <slot v-else />
  </component>
</template>
